import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import * as ReactDOM from "react-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { TwoWayAuthProvider } from "./context/TwoWayAuthContext";
import { muiTheme } from "./stylesheets/themeConfiguration";
import { i18n } from "./translations/i18n";

const siteKey: string = process.env.RECAPTCHA_SITE_KEY ?? "";

ReactDOM.render(
    <BrowserRouter>
        <MuiThemeProvider theme={muiTheme}>
            <I18nextProvider i18n={i18n}>
                <TwoWayAuthProvider>
                    <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
                        <div style={{ display: "flex" }}>
                            <App />
                        </div>
                    </GoogleReCaptchaProvider>
                </TwoWayAuthProvider>
            </I18nextProvider>
        </MuiThemeProvider>
    </BrowserRouter>,
    document.getElementById("app")
);
